import { parseUrl } from './sanitize';

export function isHttpsUrl(value: string): boolean {
  try {
    const parsed = parseUrl(value);
    return parsed.protocol === 'https:' && parsed.hostname.length > 0;
  } catch {
    return false;
  }
}

const supportedLinkProtocols = new Set(['http:', 'https:', 'mailto:', 'sms:', 'tel:']);

export function isValidLinkUrl(value: string): boolean {
  if (value === '') return true;
  if (/\s|\\/u.test(value)) return false;
  if (/^(?:#|\/|\.\.?\/)/u.test(value) && !value.startsWith('//')) return true;

  const protocolMatch = value.match(/^([a-z][a-z\d+.-]*:)/iu);
  let url = value;

  if (protocolMatch && !supportedLinkProtocols.has(protocolMatch[1]!.toLowerCase())) {
    // The URL grammar also treats the colon in a bare host:port as a scheme
    // separator (for example, example.com:8080). Only reinterpret that form
    // when the value after the colon starts with a numeric port; otherwise an
    // unsupported scheme such as ftp.example:/payload must stay rejected.
    const portAndRest = value.slice(protocolMatch[1]!.length);
    if (!/^\d+(?:[/?#]|$)/u.test(portAndRest)) return false;
    url = `https://${value}`;
  } else if (!protocolMatch) {
    url = value.startsWith('//') ? `https:${value}` : `https://${value}`;
  }

  try {
    const parsed = new URL(url);
    if (['mailto:', 'sms:', 'tel:'].includes(parsed.protocol)) return parsed.pathname.length > 0;
    const isProtocolLessHost =
      !protocolMatch ||
      (!supportedLinkProtocols.has(protocolMatch[1]!.toLowerCase()) &&
        /^\d+(?:[/?#]|$)/u.test(value.slice(protocolMatch[1]!.length)));
    if (isProtocolLessHost) {
      const isBareHost =
        parsed.hostname === 'localhost' || parsed.hostname.includes('.') || parsed.hostname.startsWith('[');
      if (!isBareHost) return false;
    }
    return parsed.hostname.length > 0;
  } catch {
    return false;
  }
}
